export const AI_VISIBILITY_DETAIL_FILTER_OPTIONS = {
  ranges: [
    { value: 'all', label: 'All' },
    { value: 'past_7_days', label: 'Past 7 days' },
    { value: 'past_30_days', label: 'Past 30 days' },
    { value: 'past_90_days', label: 'Past 90 days' },
  ],
  models: [
    { value: 'all', label: 'All models' },
    { value: 'google_ai_mode', label: 'Google AI' },
    { value: 'chat_gpt', label: 'ChatGPT' },
    { value: 'claude', label: 'Claude' },
    { value: 'gemini', label: 'Gemini' },
    { value: 'perplexity', label: 'Perplexity' },

  ],
}

export const AI_VISIBILITY_READING_LEGEND = [
  { status: 'great', label: 'Doing great' },
  { status: 'improve', label: 'Room to improve' },
  { status: 'attention', label: 'Needs attention' },
  { status: 'new', label: 'New this week' },
]
